import React from 'react'
import ServiceSection from '../../Components/mumbai/ServiceSection'
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider'
import MaximizeModal from '../../Components/mumbai/MaximizeModal'
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection'
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection'
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper'
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection'
import LocationForm from '../../Components/mumbai/LocationForm'
import WhyChoose from '../../Components/mumbai/WhyChoose'
import EngagementModels from '../../Components/hire/EngagementModels'
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm'
const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "Mobikode's Gurugram team delivers responsive ServiceNow support, proactive maintenance, and dependable solutions to keep your business running efficiently and growing confidently.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise ",
        description: "Mobikode empowers Gurugram businesses with tailored digital solutions, helping healthcare, finance, education, retail, logistics, and real estate innovate confidently.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "Every business in Gurugram has unique goals. Mobikode delivers tailored digital solutions that simplify operations, improve efficiency, and support sustainable long-term growth.",
        image: "/assets/mumbai/img2.png"
    },

];

const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "At Mobikode, we help businesses in Gurugram streamline operations, enhance customer experiences, and accelerate growth with secure, scalable, and innovative technology solutions tailored to their evolving needs.",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "At Mobikode, we help eCommerce businesses in Gurugram grow with reliable digital solutions that enhance customer experiences, streamline operations, and support sustainable business success.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Helping Gurugram's insurance companies simplify operations, enhance customer experiences, streamline claims and policy management, and drive sustainable growth with secure, reliable, and innovative ServiceNow solutions.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "At Mobikode, we help businesses in Gurugram embrace smarter technology, streamline operations, boost productivity, and build efficient digital solutions that drive sustainable growth and lasting success.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "At Mobikode, we help businesses in Gurugram grow with intelligent digital solutions that enhance customer experiences, streamline operations, boost productivity, and deliver measurable, long-term business value.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "At Mobikode, we help Healthcare and Life Sciences organizations in Gurugram adopt smart digital solutions that enhance patient care, streamline operations, and deliver better healthcare experiences.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "Mobikode empowers media and communication businesses in Gurugram with innovative digital solutions that enhance audience engagement, simplify operations, strengthen brands, and accelerate sustainable business growth.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "At Mobikode, we help logistics and transportation businesses in Gurugram simplify operations, streamline deliveries, improve customer experiences, and grow confidently with practical digital solutions tailored to real business needs.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "At Mobikode, we help businesses in Gurugram transform ideas into scalable digital solutions, combining innovation, technology, and expertise to accelerate growth and deliver lasting value.",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "At Mobikode, we empower non-profit organizations in Gurugram with tailored technology solutions that simplify operations, strengthen community engagement, and help them create lasting social impact.",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "At Mobikode, we help businesses in Gurugram simplify operations, adopt intelligent technology, automate workflows, and deliver exceptional customer experiences through tailored, reliable digital solutions.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "At Mobikode, we empower Gurugram’s real estate businesses with smart digital solutions that simplify operations, enhance customer experiences, and strengthen connections between developers, agents, and buyers.",
        image: "/assets/mumbai/item12.png"
    },

];

function Gurugram() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Gurugram | Enterprise IT & Digital Solutions | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode provides ServiceNow consulting in Gurugram to modernize enterprise IT operations, automate workflows, improve service management, and enable efficient Enterprise AI & ServiceNow Consulting."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Gurugram, ServiceNow Consultant Gurugram, ServiceNow ITSM Gurugram, ServiceNow Enterprise IT Gurugram, ServiceNow Enterprise AI & ServiceNow Consulting Gurugram, ServiceNow Workflow Automation Gurugram, ServiceNow Implementation Gurugram, ServiceNow Integration Gurugram, ServiceNow Managed Services Gurugram, ServiceNow Solutions Gurugram"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-gurugram"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Gurugram | Enterprise IT & Digital Solutions | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Transform enterprise IT operations with Mobikode's ServiceNow consulting services in Gurugram. Automate workflows, optimize service management, integrate business systems, and improve operational efficiency."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-gurugram"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/gurugram/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Gurugram | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Explore ServiceNow solutions in Gurugram for ITSM, enterprise automation, workflow management, system integration, and Enterprise AI & ServiceNow Consulting with Mobikode."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/gurugram/bg1.png"
                />
            </Helmet>
            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Gurugram" description="Partner with Mobikode’s ServiceNow experts in Gurugram to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent digital transformation. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/gurugram.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />
            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Gurugram
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Partner with Mobikode's ServiceNow experts in Gurugram to simplify operations, empower your teams, automate everyday workflows, and accelerate sustainable business growth with confidence.
                        </p>
                    </div>
                </div>
            </section> */}
            {/* <ServiceSection image={"/assets/mumbai/gurugram.png"}
                text={"At Mobikode, we help businesses across Gurugram unlock the full potential of ServiceNow with tailored consulting and implementation services. From workflow automation and seamless integrations to platform customization and ongoing support, we deliver scalable solutions that simplify operations, improve employee experiences, boost productivity, and support long-term digital transformation and business growth."}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="At Mobikode, we help Gurugram businesses unlock the full potential of ServiceNow through tailored solutions, intelligent automation, and seamless workflows that improve efficiency and accelerate growth." />
            <HireDeveloper /> */}
        </div>
    )
}

export default Gurugram
